<template>
    <div class="wf-search">
        <div :class="`wf-search-item ${searchItem.isHide ? 'wf-search-item-hide' : ''}`" v-for="(searchItem, searchKey) in renderList" :key="searchKey">
            <label class="wf-search-item-label" for="">{{searchItem.label}}</label>
            <div class="wf-search-datePicker" :style="`width: ${searchItem.width}px`" v-if="searchItem.type === 'datePicker'">
                <DatePicker :isConfirm="searchItem.datePickerConfirm" :type="searchItem.datePickerType" :minDate="searchItem.minDate" :maxDate="searchItem.maxDate" :value="searchData[searchItem.key]" :placeholder="searchItem.placeholder" @change="handleChange($event, searchItem, searchKey)"></DatePicker>
            </div>
            <div class="wf-search-input" :style="`width: ${searchItem.width}px`" v-if="searchItem.type === 'input'">
                <Input :value="searchData[searchItem.key]" :placeholder="searchItem.placeholder" @change="handleChange($event, searchItem, searchKey)" @enter="handleSearch"></Input>
            </div>
            <div class="wf-search-select" :style="`width: ${searchItem.width}px`" v-if="searchItem.type === 'select'">
                <Select :disabled="searchItem.disabled" :clearable="searchItem.clearable" :value="searchData[searchItem.key]" :placeholder="searchItem.placeholder" :options="searchItem.options" @change="handleChange($event, searchItem, searchKey)"></Select>
            </div>
        </div>
        <div class="wf-search-search" v-if="!hideSearch">
            <Button @click="handleSearch">搜索</Button>
        </div>
        <div class="wf-search-add" v-if="showAdd">
            <Button :disabled="disabledAdd" @click="handleAdd">
                <img src="../image/search/add.png" alt="">
                {{showAddText}}
            </Button>
        </div>
        <div class="wf-search-add" v-if="showDownload">
            <Button @click="handleDownload">
                {{downloadText}}
            </Button>
        </div>
    </div>
</template>

<script>
import DatePicker from '../datePicker/datePicker.vue';
import Input from '../input/input.vue'
import Select from '../select/select.vue'
import Button from '../button/button.vue'
export default {
    components: {
        DatePicker,
        Input,
        Select,
        Button
    },
    data() {
        return {

        }
    },

    props: {
        renderList: {
            type: Array,
            default: () => {
                return []
            }
        },
        searchData: {
            type: Object,
            default: () => {
                return {}
            }
        },
        hideSearch: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
		disabledAdd: {
			type: Boolean,
            default: false
        },
        showAddText: {
            type: String,
            default: ""
        },
        showDownload: {
            type: Boolean,
            default: false
        },
        downloadText: {
            type: String,
            default: ""
        }
    },
    // model: {
    // 	prop: 'searchData',
    // 	event: 'change'
    // },
    methods: {
        // 点击搜索按钮时触发
        handleSearch() {
            this.$emit('search')
        },

        // 点击新增按钮时触发
        handleAdd() {
            this.$emit('add')
        },

        // 点击下载按钮时触发
        handleDownload() {
            this.$emit('download')
        },

        // 表单内容改变时触发
        handleChange(value, searchItem, searchKey) {
            const searchData = { ...this.searchData }
            searchData[searchItem.key] = value
            this.$emit('change', {
                data: searchData,
                item: searchItem,
                index: searchKey
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.wf-search {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .wf-search-item {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-right: 30px;
        margin-bottom: 20px;
        .wf-search-item-label {
            margin-right: 10px;
        }
        .wf-search-datePicker {
            position: relative;
            width: 160px;
            /deep/ .ivu-date-picker {
                width: 100%;
            }
        }
        .wf-search-input {
            width: 160px;
        }
        .wf-search-select {
            width: 84px;
        }
    }

    .wf-search-item-hide {
        display: none;
    }
    .wf-search-search {
        width: 60px;
        margin-right: 30px;
        margin-bottom: 20px;
    }

    .wf-search-add {
        margin-bottom: 20px;
        .wf-button {
            padding: 0 16px;
        }
        img {
            width: 11px;
            height: 11px;
            margin-right: 4px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/search/search.vue